export interface User
{
    id: string;
    firstname: string;
    surname: string;
    accountType: string;
    colour: string;
    isPremium?: number;
    avatarColour?: string;

    callRing: number;
    username: string;
    createdAt: Date;
    terms: number;
    marketing: number;
    guest: number;
    stripeId: string;
    rewardDiscount: number;
    adminMaxDiscount: number;
    adminMaxRewardPoints: number;
    online: number;
    lastSeen: Date;
    blacklisted: number;
    prospect: number;
    callTimeOut: null;
    inboundRingtone: string;
    twNumbers: TwNumber[];
    address: Address;
    contact: Contact;
    permissions: any;
}

export interface TwNumber
{
    id: number;
    twilioNrId: string;
    createdAt: Date;
    updatedAt: Date | null;
    isPrivate: number;
    domainId: string;
}

export interface Address
{
    id: string;
    userId: string;
    createdAt: Date;
    add1: string;
    add2: string;
    add3: string;
    town: string;
    county: string;
    postcode: string;
    country: string;
    lat: null;
    lng: null;
    status: number;
    deleted: number;
    defaultDeliveryAddress: number;
    createdBy: null;
    isBilling: number;
    restrictionGravel: number;
    restrictionSlope: number;
    restrictionBoards: number;
    isCollection: number;
}

export interface Contact
{
    id: string;
    userId: string;
    createdAt: Date;
    companyId: string;
    addressId: string;
    firstname: string;
    surname: string;
    avatar: null;
    email: string;
    mobile: string;
    landline: string;
    jobTitle: string;
    status: number;
    deleted: number;
    createdBy: string;
    fullAddress: string;
    companyName: string;
    contactId: number;
    mobDialCode: string;
    isWarm: number;
    altPhone: null;
    domainId: string;
}

export const UserEvent = {
    Updated: 'user.updated'
};

export interface UserEventData
{
    userId: string;
}
